import { createAction, props } from '@ngrx/store';
import {
  IndReportsTemplateBaseModel,
  IndReportsTemplateDomainModel,
  IndReportsTemplateModel,
  IndReportsTemplateScaleModel,
} from './indTemplate.model';

export const IndTemplateActions = {
  loadTemplate: createAction('[Individual Reports Template Builder] Load', props<{ measureOId: number }>()),
  loadTemplateSuccess: createAction(
    '[Individual Reports Template Builder] Load Success',
    props<{ template: IndReportsTemplateModel }>(),
  ),
  loadTemplateFailure: createAction('[Individual Reports Template Builder] Load Failure', props<{ error: string }>()),
  resetStore: createAction('[Measure] Reset Store'),

  updateTemplateDomain: createAction(
    '[Individual Reports Template Builder] Update Individual Report Domain',
    props<{ updatedDomain: IndReportsTemplateDomainModel }>(),
  ),
  updateTemplateScale: createAction(
    '[Individual Reports Template Builder] Update Individual Report Scale',
    props<{ updatedScale: IndReportsTemplateScaleModel }>(),
  ),
  updateTemplateScaleItem: createAction(
    '[Individual Reports Template Builder] Update Individual Report Item',
    props<{ updatedItem: IndReportsTemplateBaseModel }>(),
  ),
  updateTemplateBuilderPage: createAction(
    '[Individual Reports Template Builder] Update Template per Page',
    props<{ data: Partial<IndReportsTemplateModel> }>(),
  ),
  saveTemplateBuilder: createAction(
    '[Individual Reports Template Builder] Save Template',
    props<{ measureOId: number; data: IndReportsTemplateModel }>(),
  ),
  saveTemplateBuilderSuccess: createAction('[Individual Reports Template Builder] Save Success'),
  saveTemplateBuilderFailure: createAction(
    '[Individual Reports Template Builder] Save Failure',
    props<{ error: string }>(),
  ),
};
